export const timezoneOptions = [
  { value: 'Europe/Madrid', label: 'Europa/Madrid (CET/CEST)' },
  { value: 'UTC', label: 'UTC' },
  { value: 'Europe/London', label: 'Europa/Londres' },
  { value: 'Europe/Lisbon', label: 'Europa/Lisboa' },
  { value: 'Europe/Paris', label: 'Europa/París' },
  { value: 'Europe/Berlin', label: 'Europa/Berlín' },
  { value: 'America/New_York', label: 'América/Nueva York' },
  { value: 'America/Los_Angeles', label: 'América/Los Ángeles' },
  { value: 'America/Chicago', label: 'América/Chicago' },
  { value: 'America/Mexico_City', label: 'América/Ciudad de México' },
  { value: 'America/Bogota', label: 'América/Bogotá' },
  { value: 'America/Argentina/Buenos_Aires', label: 'América/Buenos Aires' },
  { value: 'America/Sao_Paulo', label: 'América/São Paulo' },
  { value: 'Africa/Casablanca', label: 'África/Casablanca' },
  { value: 'Asia/Dubai', label: 'Asia/Dubái' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokio' },
];
